module.exports = __webpack_public_path__ + "static/media/banner_humankind.40f5a028.png";